import { customizeError, formatCurrency, formatDate, formatPercentage } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { ANNUAL_PURCHASE_PLAN_TABS, MONTHS } from '../../config/settings/constant'
import { getAnnualPurchasePlan } from '../../services/annualPurchasePlan'

export const GET_ANNUAL_PURCHASE_PLAN = 'GET_ANNUAL_PURCHASE_PLAN'
export const GET_ANNUAL_PURCHASE_PLAN_ERROR = 'GET_ANNUAL_PURCHASE_PLAN_ERROR'
export const GET_ANNUAL_PURCHASE_PLAN_SUCCESS = 'GET_ANNUAL_PURCHASE_PLAN_SUCCESS'
export const onGetAnnualPurchasePlan = makeActionCreator(GET_ANNUAL_PURCHASE_PLAN)
export const onGetAnnualPurchasePlanError = makeActionCreator(GET_ANNUAL_PURCHASE_PLAN_ERROR, 'payload')
export const onGetAnnualPurchasePlanSuccess = makeActionCreator(GET_ANNUAL_PURCHASE_PLAN_SUCCESS, 'payload')
export const onGetAnnualPurchasePlanThunk = payload => async dispatch => {
  dispatch(onGetAnnualPurchasePlan())

  try {
    const {
      data: { payload: response }
    } = await getAnnualPurchasePlan({ actionType: GET_ANNUAL_PURCHASE_PLAN, dni: payload.dni })
    const { data } = response
    const hasData = data.length > 0

    const updateDate = hasData ? formatDate(new Date(response.fechaActualizacion), 'dd-MM-yyyy HH:mm:ss') : null
    const publicationDate = hasData ? formatDate(new Date(response.fechaPublicacion), 'dd-MM-yyyy') : 'sin fecha'

    const gridData = data.map(item => {
      const month = MONTHS[item.mes - 1]
      const capitalMonth = month.charAt(0).toUpperCase() + month.slice(1)
      return {
        month: capitalMonth,
        year: item.agno,
        plannedAmount: formatCurrency(item.montoPlanificado, '$'),
        executedAmount: formatCurrency(item.montoEjecutado, '$'),
        percent: formatPercentage(item.porcentajeEjecutado)
      }
    })

    const chartDataPlaning = data.map(item => item.montoPlanificado)
    const chartDataExecuted = data.map(item => item.montoEjecutado)
    const chartData = [
      {
        name: 'Monto Planificado',
        data: chartDataPlaning,
        color: ANNUAL_PURCHASE_PLAN_TABS.DATA_CHART.COLORS.PLANNED,
        footer: ANNUAL_PURCHASE_PLAN_TABS.DATA_CHART.FOOTER.PLANNED
      },
      {
        name: 'Monto Ejecutado',
        data: chartDataExecuted,
        color: ANNUAL_PURCHASE_PLAN_TABS.DATA_CHART.COLORS.EXECUTED,
        footer: ANNUAL_PURCHASE_PLAN_TABS.DATA_CHART.FOOTER.EXECUTED
      }
    ]
    const months = gridData.map(item => item.month)
    const monthsShort = gridData.map(item => item.month.substring(0, 3))
    const excelData = gridData.map(item => {
      return {
        Mes: item.month,
        Año: item.year,
        'Monto planificado para el mes': item.plannedAmount,
        'Monto ejecutado en el mes': item.executedAmount,
        'Porcentaje ejecutado': item.percent
      }
    })

    return dispatch(
      onGetAnnualPurchasePlanSuccess({
        hasData,
        updateDate,
        publicationDate,
        categories: {
          months,
          monthsShort
        },
        chartData,
        gridData,
        excelData
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetAnnualPurchasePlanError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
